import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaEye,
  FaMinus,
  FaPlus,
  FaStickyNote,
  FaRegFileAlt,
  FaTimes,
  FaExclamationTriangle,
} from "react-icons/fa";
import { BiErrorCircle } from "react-icons/bi";
import { GrRotateLeft } from "react-icons/gr";
import { API_Link, API_SRC, validateHeader } from "../../commons/Constants";
// import ReactTimeAgo from "react-time-ago";
import "./../../assets/sass/style.css";
import "./../../assets/sass/totalreview.css";
//import  "./../../assets/sass/_screening.scss"
import axios from "axios";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Button, Modal, Tab, Tabs, ProgressBar, Form } from "react-bootstrap";
import paperclip from "./../../assets/img/icon/paperclip.svg";
import { useSelector } from "react-redux";
import gif from "./../../assets/img/spin.gif";
import { useSnackbar } from "notistack";
import NoteComponent from "../noteComponent";
import { FiFilter } from "react-icons/fi";
import { BsSortAlphaDown } from "react-icons/bs";
import Select from "react-select";
import parse from "html-react-parser";

function TotalReviews(props) {
  const MD5hash = validateHeader();
  const { enqueueSnackbar } = useSnackbar();
  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }

    return str
      .split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }
  const [permission1] = useSelector((state) => state.getPermission.data || []);
  const [options, setOptions] = useState([]);
  const [exclusionPurpose, setexclusionPurpose] = useState([]);
  const [isGreen, setIsGreen] = useState(new Array(options.length).fill(false));
  const [articleData, setArticleData] = useState([]);
  const formatOvidTags = (text) => {
    if (!text) return "";

    const formattedText = text
      .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<br><b>$1</b>")
      .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
      .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
      .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
      .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
      .replace(/<ovid:br\/>/g, "<br>")
      .replace(
        /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
        "<a href='$1'>$2</a>"
      )
      .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
      .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
      .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>");
    return formattedText.replace(
      /^(<.*?>)*(\w)/,
      (match, tags, firstLetter) => `${tags || ""}${firstLetter.toUpperCase()}`
    );
  };
  // const [isRed, setIsRed] = useState(new Array(options.length).fill(false));
  const [isRed, setIsRed] = useState([]);
  const [show, setShow] = useState(false);
  const [tabKey, initTabKey] = useState("one");
  const [excluded, setExcluded] = useState([]);
  const ref = React.useRef();
  const [height, setHeight] = React.useState("0px");
  const user = JSON.parse(localStorage.getItem("user"));
  const studyId = localStorage.getItem("studyId");
  const token = user?.token;
  const [selectArticle, setSelectArticle] = useState([]);
  const [progress, setProgress] = useState(0);
  // call for get reviewer permissions
  const dropdownRef = useRef(null);

  const [getPermission, setGetPermission] = useState([]);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [dataSetUrl, setDataSetUrl] = useState("");
  const [isError, setIsError] = useState(false);
  const [article, setArticle] = useState([]);
  const [articleId, setArticleId] = useState([]);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [notes, setNotes] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [savedNotes, setSavedNotes] = useState({});
  const [progress1, setProgress1] = useState(0);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [normalizedValues, setNormalizedValues] = useState([]); // State for normalized values
  const [activeAbstract, setActiveAbstract] = useState(null);
  const [text, settext] = useState([]);
  const [total, setTotal] = useState();
  const [TotalInclude, setTotalInclude] = useState();
  const [TotalExclude, setTotalExclude] = useState();
  const [isFetchingArticlesAPICalled, setIsFetchingArticlesAPICalled] =
    useState(false);

  const toggleAbstract = (index) => {
    setActiveAbstract(activeAbstract === index ? null : index);
  };
  useEffect(() => {
    setFilteredArticles(options);
  }, [options]);
  const toggleFilterModal = () => {
    getFilteredArticles();
    setShowFilterModal(!showFilterModal);
  };

  const OpenFilterModal = () => {
    setShowFilterModal(!showFilterModal);
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const selectOptions = currentOptions?.map((option) => {
    let labelPrefix = "";
    switch (filterType) {
      case "year":
        labelPrefix = "year";
        break;
      case "author":
        labelPrefix = "authors";
        break;
      case "journal":
        labelPrefix = "journal";
        break;
      default:
        break;
    }

    // Return the option with prefixed label
    return {
      value: option,
      label: option,
      labelPrefix: labelPrefix,
    };
  });
  const toggleCloseModal = () => {
    setOptions([]);
    setSelectedOptions([]);
    setCurrentOptions([]);
    settext([]);
    setNormalizedValues([]);
    setFilterType("");
    getReviewArticles();
    setFilteredArticles(options);
    setShowFilterModal(!showFilterModal);
  };
  const toggleHideModal = () => {
    setShowFilterModal(!showFilterModal);
  };

  const journals = [...new Set(options?.map((article) => article?.journal))];

  // Sort articles based on selected field
  const sortArticles = (field) => {
    const sorted = [...filteredArticles].sort((a, b) => {
      const valueA = a[field] ? a[field].toString().toLowerCase() : "";
      const valueB = b[field] ? b[field].toString().toLowerCase() : "";
      return valueA.localeCompare(valueB);
    });
    setFilteredArticles(sorted); // Call the parent callback with sorted array
    setShowDropdown(false); // Hide dropdown after selection
  };
  const handleFilterChange = (type) => {
    setFilterType(type);
    const normalizedValues = selectedOptions.reduce(
      (acc, option) => {
        if (!acc[option.labelPrefix]) acc[option.labelPrefix] = [];
        acc[option.labelPrefix].push(option.value.toString().toLowerCase());
        return acc;
      },
      { authors: [], journal: [], year: [] }
    );

    const { authors, journal, year } = normalizedValues;

    switch (type) {
      case "year":
        const filteredYears =
          authors.length === 0 && journal.length === 0
            ? [...new Set(articleData?.map((article) => article.year))]
            : articleData
                .filter(
                  (article) =>
                    (authors.length === 0 ||
                      authors.some((author) =>
                        article.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                ?.map((article) => article.year)
                .filter((year, index, self) => self.indexOf(year) === index);

        setCurrentOptions(filteredYears.sort((a, b) => b - a));
        break;

      case "author":
        const filteredAuthors =
          year.length === 0 && journal.length === 0
            ? [
                ...new Set(
                  articleData.flatMap((article) =>
                    article.authors
                      .split(",")
                      ?.map((a) => a.trim().toLowerCase())
                  )
                ),
              ]
            : articleData
                .filter(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                .flatMap((article) =>
                  article.authors.split(",")?.map((a) => a.trim().toLowerCase())
                )
                .filter(
                  (author, index, self) => self.indexOf(author) === index
                ); // Remove duplicates

        // Capitalize the first letter of each word in the filtered authors
        const capitalizedAuthors = filteredAuthors?.map(capitalizeWords);
        setCurrentOptions(capitalizedAuthors);
        break;

      case "journal":
        const filteredJournals =
          year.length === 0 && authors.length === 0
            ? journals
            : journals.filter((journal) =>
                articleData.some(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (authors.length === 0 ||
                      authors.some((author) =>
                        article.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    article.journal.toLowerCase() === journal.toLowerCase()
                )
              );

        setCurrentOptions(filteredJournals?.map(capitalizeWords));
        break;

      default:
        setCurrentOptions([]);
        break;
    }
  };

  const highlightText = (text) => {
    if (!normalizedValues || typeof text !== "string") return text; // Ensure text is a string
    const highlighted = normalizedValues?.find((value) =>
      text?.toLowerCase().includes(value)
    );
    if (!highlighted) return text;

    const parts = text.split(new RegExp(`(${highlighted})`, "gi"));
    return parts?.map((part, index) =>
      part?.toLowerCase() === highlighted ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const handleOpenModal2 = (index, id) => {
    setShowModal2(true);

    options.find((article) => {
      if (article.id === id) {
        setArticle([article]);
        setArticleId(article.id);
        setDataSetUrl(article.source);
      } else {
        // return article;
      }
    });
  };

  const handleCloseModal2 = () => {
    setShowModal2(false);
    setSelectedFile([]);
    setgetFileName("");
    setIsFileUploaded(false);
    setDataSetUrl("");
  };

  const getPermissionCall = () => {
    var config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${localStorage.getItem(
        "studyId"
      )}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        setGetPermission(response.data.permissions[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // code for capitalize
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  function shouldBeUppercase(word, index, length) {
    //always capitalize the first and last words
    if (index == 0 || index == length - 1) return true;

    //only capitalize other words if they don't match the small words pattern
    return !smallWords.test(word.toLowerCase());
  }

  function convertFirstLetterToUpperCase(str) {
    //split into words
    const words = str.split(" ");

    //change the case and rejoin into a string
    return words
      ?.map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.toLowerCase()
      )
      .join(" ");
  }
  const getlookup = () => {
    var config = {
      method: "get",
      url: `${API_Link}getLookupsList?options=true&title=exclusion_purpose`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;

        const purpose = resData.data.lookups[0].options;
        console.warn(purpose);
        const filterExclusionPurpose = purpose.filter(
          (item) => item.value !== 1 && item.value !== 9
        );
        setexclusionPurpose(filterExclusionPurpose);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleTitleSearch = (searchTerm) => {
    const titleSearchTerm = searchTerm;
    settext(titleSearchTerm);
  };
  const [payloadArray, setPayloadArray] = useState([]);
  const [isFeatchingArticles, setIsFeatchingArticles] = useState(false);

  const getReviewArticles = async () => {
    setIsFeatchingArticles(true);

    let page = 1;
    const perPage = 25;
    let totalPages = 1;
    let allResults = [];

    try {
      do {
        var config = {
          method: "get",
          url: `${API_Link}getReviewArticles?review_id=${studyId}&fulltext=Yes`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
          params: {
            page: page,
            per_page: perPage,
          },
        };

        const response = await axios(config);
        const resData = response?.data;
        setTotal(resData?.articles?.total);
        setTotalInclude(resData?.include);
        setTotalExclude(resData?.exclude);
        allResults = [...allResults, ...resData?.articles?.data];

        totalPages = resData?.articles?.last_page;
        page++;

        const progressPercent = Math.min((page / totalPages) * 100, 100);
        setProgress(progressPercent);

        let currentRecord = allResults.filter(
          (option) => option.current_stage > 3
        );

        let partialStudentDetails = currentRecord?.map(
          ({ id, abstract_screening, reason }) => ({
            id,
            abstract_screening: 1,
          })
        );

        let excludedAPI = allResults.filter((option) => option.reason !== null);

        let letExcluded = excludedAPI?.map(
          ({ id, abstract_screening, reason }) => ({
            id,
            reason,
            abstract_screening: 0,
          })
        );

        setPayloadArray(partialStudentDetails);
        setPayloadArray((current) => [...current, ...letExcluded]);

        const processedOptions = allResults?.map((item) => {
          if (item.current_stage > 3) {
            return {
              ...item,
              abstract_screening: 0,
            };
          } else if (item.reason !== null) {
            return {
              ...item,
              abstract_screening: 1,
            };
          }
          return item;
        });

        const sortedArticlesFilePath = processedOptions.sort((a, b) => {
          if (a.file_path === null && b.file_path !== null) {
            return 1;
          } else if (a.file_path !== null && b.file_path === null) {
            return -1;
          }
          return 0;
        });
        const sortedArticlesInclude = sortedArticlesFilePath.sort((a, b) => {
          if (a.current_stage !== b.current_stage) {
            return b.current_stage - a.current_stage;
          }
          return 0;
        });

        setOptions(sortedArticlesInclude);
        const notesTemp = allResults.reduce((acc, article) => {
          acc[article.id] = article.full_text_note;
          return acc;
        }, {});

        setNotes(notesTemp);
        const notesSaveTemp = allResults.reduce((acc, article) => {
          if (article.full_text_note !== null) {
            acc[article.id] = true;
          }

          return acc;
        }, {});

        setSavedNotes(notesSaveTemp);
        setSelectArticle(allResults.filter((option) => option.reason !== null));
      } while (page <= totalPages);

      // Set progress to 100% and hide progress bar after a delay
      setProgress(100);
    } catch (error) {
      console.log(error);
      setIsError(true);
    } finally {
      setIsFeatchingArticles(false);
      setIsFetchingArticlesAPICalled(true);
    }
  };
  const getData = () => {
    var config = {
      method: "get",
      url: `${API_Link}optionfilter`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        review_id: studyId,
        fulltext: "Yes",
      },
    };
    axios(config)
      .then(function (response) {
        setArticleData(response?.data?.articles);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getFilteredArticles = () => {
    const authors = selectedOptions
      .filter((option) => option.labelPrefix === "authors")
      ?.map((option) => option.value)
      .join(",");

    const journals = selectedOptions
      .filter((option) => option.labelPrefix === "journal")
      ?.map((option) => option.value)
      .join(",");

    const years = selectedOptions
      .filter((option) => option.labelPrefix === "year")
      ?.map((option) => option.value)
      .join(",");

    const title = text;
    var config = {
      method: "get",
      url: `${API_Link}filterArticles`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        review_id: studyId,
        fulltext: "Yes",
        ...(authors && { author: authors }),
        ...(journals && { journal: journals }),
        ...(years && { year: years }),
        ...(title && { title: title }),
      },
    };

    axios(config)
      .then(function (response) {
        setOptions(response?.data?.articles);
        setNormalizedValues(selectedOptions);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getPermissionCall();
    getData();
    getReviewArticles();
    getlookup();
  }, []);

  const [isActive, setIsActive] = useState(null);
  const navigate = useNavigate();
  //handle increase Decrease Height
  const handleClick = (index) => {
    if (isActive === index) {
      return setIsActive(null);
    }
    setIsActive(index);
  };

  // handle Include
  const handleInclude = (index, id) => {
    handlestatus(index, id, 1);
  };

  // handle Exclude

  const handleExclude = (index, id, abstract_screening, reason) => {
    handlestatus(index, id, 0, 2);
  };

  //handle Undo

  const handleUndo = (index, id, current_stage, reason) => {
    handlestatus(index, id, null, reason, current_stage);
  };

  const handleCloseModal = (index) => {
    setShow(false);
  };

  const [file, setFile] = useState();
  const [source, setSource] = useState();
  const handleOpenModal = (index, id) => {
    const selectedArticle = options.find((article) => article.id === id);

    if (selectedArticle) {
      setFile(selectedArticle.file_path);
      setSource(selectedArticle.source);
    }

    setShow(true);
  };

  //

  const [selectedClient, setSelectedClient] = useState(
    new Array(exclusionPurpose.length).fill([])
  );

  function handleSelectChange(event, index, id) {
    event.preventDefault();

    let newid = id;

    const newArray = payloadArray?.map((item, id) => {
      if (item.id === newid) {
        return { ...item, reason: event.target.value };
      } else {
        return item;
      }
    });

    const uniqueDataPayload = [];
    const ids = new Set();

    // Iterate through the array in reverse
    for (let i = newArray.length - 1; i >= 0; i--) {
      const item = newArray[i];
      if (!ids.has(item.id)) {
        ids.add(item.id);
        uniqueDataPayload.push(item);
      }
    }

    setPayloadArray(uniqueDataPayload);

    exclusionPurpose?.map((value) => {
      let result = [...selectedClient];
      result[index] = event.target.value;

      setSelectedClient(result);
    });
  }
  const selectchange = (options) => {
    setSelectedOptions(options || []);
  };

  const handleFinalExclusion = async () => {
    let data = {
      review_id: studyId,
      stage: "3",
      articles: payloadArray,
      // reasons: reasons,
    };

    await axios
      .post(`${API_Link}excludeArticles`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
      })
      .then((res) => res.data)
      .finally(() => navigate("/includedfulltext"));
  };

  const handlestatus = async (
    index,
    id,
    abstract_screening,
    reason,
    current_stage
  ) => {
    const payloadArray = [
      {
        id: id,
        abstract_screening: abstract_screening,
        ...(reason && { reason: reason }),
      },
    ];
    let data = {
      review_id: studyId,
      stage: "3",
      articles: payloadArray,
      // reasons: reasons,
    };

    await axios
      .post(`${API_Link}excludeArticles`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
      })
      .then((res) => {
        if (abstract_screening == 1) {
          TotalInclude.push(id);
          let result = [...isGreen];
          result[index] = !result[index];
          setIsGreen(result);
          let currentRecord = options.filter((option) => option.id === id);
          let partialStudentDetails = currentRecord?.map(
            ({ id, abstract_screening, reason }) => ({
              id,
              abstract_screening: 1,
            })
          );
          setPayloadArray((current) => [...current, partialStudentDetails[0]]);
        } else if (abstract_screening == 0) {
          TotalExclude.push(id);
          let result = [...isRed];
          result[index] = !result[index];
          setIsRed(result);

          let currentRecord = options.filter((option) => option.id === id);

          let partialStudentDetails = currentRecord?.map(
            ({ id, abstract_screening, reason }) => ({
              id,
              abstract_screening: 0,
              reason: 2,
            })
          );
          setPayloadArray((current) => [...current, partialStudentDetails[0]]);
          options?.map((article) => {
            let result = [...selectArticle];
            result[index] = article.id;
            if (article.id === id) {
              setSelectArticle(result);
            } else {
            }
          });
        } else if (abstract_screening == null) {
          if (TotalInclude.includes(id)) {
            const index = TotalInclude.indexOf(id);
            TotalInclude.splice(index, 1);
          }

          if (TotalExclude.includes(id)) {
            const index = TotalExclude.indexOf(id);
            TotalExclude.splice(index, 1);
          }
          let newid = id;
          if (current_stage > 3) {
            const newData = options?.map(({ id, ...datum }) =>
              id === newid
                ? { id, ...datum, current_stage: 3 }
                : { id, ...datum }
            );

            const newData1 = payloadArray?.map(({ id, ...datum }) =>
              id === newid
                ? { id, ...datum, current_stage: 3, abstract_screening: null }
                : { id, ...datum }
            );

            setOptions(newData);
            setPayloadArray(newData1);
          }

          if (current_stage === 3 && reason !== null) {
            const newData = options?.map(({ id, ...datum }) =>
              id === newid
                ? { id, ...datum, reason: null, abstract_screening: null }
                : { id, ...datum }
            );

            const newData1 = payloadArray?.map(({ id, ...datum }) =>
              id === newid
                ? { id, ...datum, abstract_screening: null }
                : { id, ...datum }
            );

            setOptions(newData);
            setPayloadArray(newData1);
          }

          if (isGreen[index]) {
            let result1 = [...isGreen];
            result1[index] = !result1[index];
            setIsGreen(result1);
            let currentRecord = options.filter((option) => option.id === id);
            let partialStudentDetails = currentRecord?.map(
              ({ id, abstract_screening, reason }) => ({
                id,
                abstract_screening: 1,
              })
            );
            setPayloadArray((current) => [
              ...current,
              partialStudentDetails[0],
            ]);
            let result = payloadArray.filter((article) => article.id !== id);
            setPayloadArray(result);
          } else if (isRed[index]) {
            let result1 = [...isRed];
            result1[index] = !result1[index];
            setIsRed(result1);

            let currentRecord = options.filter((option) => option.id === id);

            let partialStudentDetails = currentRecord?.map(
              ({ id, abstract_screening, reason }) => ({
                id,
                abstract_screening: 0,
                reason: 2,
              })
            );
            setPayloadArray((current) => [
              ...current,
              partialStudentDetails[0],
            ]);
            options?.map((article) => {
              let result = [...selectArticle];
              result[index] = article.id;
              if (article.id === id) {
                setSelectArticle(result);
              } else {
              }
            });
            let result = payloadArray.filter((article) => article.id !== id);
            setPayloadArray(result);
          }
        }
      })
      .finally(() => {});
  };

  const countExcluded = (type = 0) => {
    const countTypes = payloadArray.filter(
      (article) => article.abstract_screening === type
    );
    return countTypes.length;
  };

  const countMaybe = () => {
    const countTypes = total - (TotalInclude?.length + TotalExclude?.length);
    return countTypes;
  };

  //
  const [showDelete, setShowDelete] = useState(false);
  const [getFileName, setgetFileName] = useState("");

  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const handleDeleteArticle = () => {
    // getId
  };

  // Handle File Upload
  const [isFileSubmitting, setIsFileSubmitting] = useState(false);
  const handleSubmit = async (event, index) => {
    event.preventDefault();
    setIsFileSubmitting(true);

    // console.warn("result submit", result);
    var formData = new FormData();
    formData.append("review_id", localStorage.getItem("studyId") || 1);
    formData.append("file", selectedFile);
    formData.append("id", articleId);

    await axios
      .post(`${API_Link}uploadFulltextData`, formData, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error("Response status is not 200");
        } else if (res.data.status === 1) {
          getReviewArticles();
          enqueueSnackbar("File Uploaded Successfully", {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } else {
        }
      })
      .catch((error) => {
        console.error(error.message);
        setIsFileSubmitting(false);
        enqueueSnackbar("Failed to Uplaod File", {
          variant: "error",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      })
      .finally(() => {
        setShowModal2(false);
        setIsFileSubmitting(false);
        setSelectedFile([]);
        setgetFileName("");
      });

    // window.location.reload(false);
  };

  const handleFileSelect = (event) => {
    //
    const selectedFile = event.target.files[0];
    const fileSizeInBytes = selectedFile.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // convert bytes to MB

    if (fileSizeInMB > 3) {
      console.error("File size exceeds the limit of 3 MB");
      // handle the error appropriately
      return alert("File size exceeds the limit of 3 MB");
    } else {
      setShowProgressBar(true);
      setProgress1(0);
      const interval = setInterval(() => {
        setProgress1((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setIsFileUploaded(true); // File is considered uploaded after 2 seconds
            setShowProgressBar(false); // Hide progress bar after upload
          }
          return prev + 25;
        });
      }, 500);
      setDataSetUrl("");
      setSelectedFile(event.target.files[0]);
      setgetFileName(event.target.files[0].name);
    }
  };
  // handle Cahnge
  const handleChange = (e) => {
    setDataSetUrl(e.target.value);
    setError(""); // Clear error message when typing
  };

  const [error, setError] = useState("");
  const isValidURL = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+([a-z]{2,}|[a-z\\d-]{2,})|" + // domain name
        "localhost|" + // localhost
        "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|" + // IPv4
        "\\[?[a-fA-F\\d]*:[a-fA-F\\d:]+\\]?)" + // IPv6
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(url);
  };
  const handleUrlSubmit = async (e) => {
    e.preventDefault();
    if (isValidURL(dataSetUrl)) {
      // Reset error if the URL is valid
      setError("");

      // Your form submission logic
      const formData = new FormData();
      formData.append("review_id", localStorage.getItem("studyId") || 1);
      formData.append("source", dataSetUrl);
      formData.append("id", articleId);

      await axios
        .post(`${API_Link}uploadFulltextData`, formData, {
          headers: {
            "misr-auth": MD5hash,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {})
        .finally(() => setShow(false));
      window.location.reload(false);
    } else {
      // Set error message if URL is invalid
      setError("Please enter a valid URL.");
    }
  };

  const handleChangeNote = (e, articleId) => {
    const { value } = e.target;
    setNotes((prevNotes) => ({
      ...prevNotes,
      [articleId]: value, // Update note for the specific article
    }));
  };

  const handleSaveNote = async (articleId) => {
    const noteToSave = notes[articleId];
    setIsSavingNote(true);
    const data = {
      article_id: articleId,
      note: noteToSave,
      full_text: "Yes",
    };
    try {
      const config = {
        method: "post",
        url: `${API_Link}addNote`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: data,
      };

      const res = await axios(config);
      if (res?.data?.note === null) {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: false,
        }));
      } else {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: true,
        }));
      }
    } catch (error) {
      enqueueSnackbar("An Error Occurs While Saving Note", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } finally {
      setIsSavingNote(false); // This will always run after the try or catch block
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFileSelect({ target: { files: [file] } });
  };
  const handleCancelFile = () => {
    setSelectedFile([]);
    setgetFileName("");
    setIsFileUploaded(false);
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  function capitalizeTextProperly(text) {
    // Capitalize the first letter of the text
    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Capitalize the first word after specified punctuation marks
    return text.replace(/([.?!:;]\s*)([a-z])/g, (match, punct, char) => {
      // Capitalize the character following the punctuation
      return punct + char.toUpperCase();
    });
  }

  return (
    <>
      <div className="page--content" onClick={handleClickOutside}>
        <div className="">
          <div className="position-sticky position-sticky-top z-index-9">
            <div className="page--section">
              <div className="row d-flex">
                <div className="col-lg-6">
                  <h1 className="page--heading">Fulltext Screening</h1>
                </div>

                <div className="col-lg-6">
                  {getPermission && getPermission.includes(3) ? (
                    <ul className="ul-export ms-2">
                      <button
                        className={
                          isFeatchingArticles
                            ? "btn btn-danger cursor-not-allowed"
                            : "btn btn-danger"
                        }
                        onClick={handleFinalExclusion}
                        disabled={isFeatchingArticles}
                      >
                        Excluded article ({countExcluded()})
                      </button>
                    </ul>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row mt-3 count-colour d-flex align-items-center justify-content-center">
                <div className="col-lg-6 text-start">
                  <div
                    style={{
                      position: "relative",
                      display: "inline-flex",
                      alignItems: "center",
                      marginLeft: "8px",
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      className={
                        filteredArticles?.length === 0
                          ? "sort-filter-btn opacity-50 cursor-not-allowed"
                          : "sort-filter-btn "
                      }
                    >
                      Sort <BsSortAlphaDown style={{ fontSize: "20px" }} />
                    </button>
                    {showDropdown && (
                      <div
                        ref={dropdownRef}
                        style={{
                          position: "absolute",
                          top: "30px",
                          left: 0,
                          backgroundColor: "#ffff",
                          boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                          zIndex: 1,
                          padding: "8px",
                        }}
                      >
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("title")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Title
                        </div>
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("journal")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Journal
                        </div>
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("authors")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Authors
                        </div>
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("abstract")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Abstract
                        </div>
                      </div>
                    )}
                    <button
                      onClick={OpenFilterModal}
                      className={
                        filteredArticles?.length === 0
                          ? "sort-filter-btn opacity-50 cursor-not-allowed"
                          : "sort-filter-btn "
                      }
                    >
                      Filter <FiFilter style={{ fontSize: "20px" }} />
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 text-end">
                  <span>
                    <span className="me-3 text-style">
                      Total: <strong>{total}</strong>
                    </span>
                    <span className="me-3 text-success">
                      Included: <strong>{TotalInclude?.length}</strong>
                    </span>
                    <span className="me-3 text-danger">
                      Excluded: <strong>{TotalExclude?.length}</strong>
                    </span>
                    <span className="me-3">
                      Undecided: <strong>{countMaybe()}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <Modal
                show={showFilterModal}
                onHide={toggleHideModal}
                className="overflow-hidden"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Filter Options</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Form className="d-flex justify-content-around mb-2">
                      <Form.Check
                        type="radio"
                        label="Year"
                        name="filterType"
                        value="title"
                        checked={filterType === "year"}
                        onChange={() => handleFilterChange("year")}
                      />
                      <Form.Check
                        type="radio"
                        label="Author"
                        name="filterType"
                        value="author"
                        checked={filterType === "author"}
                        onChange={() => handleFilterChange("author")}
                      />
                      <Form.Check
                        type="radio"
                        label="Journal"
                        name="filterType"
                        value="journal"
                        checked={filterType === "journal"}
                        onChange={() => handleFilterChange("journal")}
                      />
                      <Form.Check
                        type="radio"
                        label="Title"
                        name="filterType"
                        value="title"
                        checked={filterType === "title"}
                        onChange={() => handleFilterChange("title")}
                      />
                    </Form>
                    <Select
                      options={selectOptions}
                      isMulti
                      value={selectedOptions}
                      onChange={selectchange}
                      closeMenuOnSelect={false}
                      placeholder="Select filter options..."
                      isDisabled={filterType === "title"}
                    />

                    {filterType === "title" ? (
                      <input
                        type="text"
                        placeholder="Search by title..."
                        className="form-control"
                        value={text}
                        onChange={(e) => handleTitleSearch(e.target.value)}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  {selectedOptions.length > 0 || text.length > 0 ? (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        toggleCloseModal();
                      }}
                    >
                      Reset
                    </Button>
                  ) : (
                    <Button
                      variant="secondary"
                      disabled
                      className="opacity-50 "
                    >
                      Reset
                    </Button>
                  )}
                  {selectedOptions.length || text.length > 0 ? (
                    <Button
                      variant="primary"
                      onClick={() => {
                        toggleFilterModal();
                      }}
                    >
                      Apply Filter
                    </Button>
                  ) : (
                    <Button
                      className="opacity-50 "
                      // variant="primary"
                      disabled
                    >
                      Apply Filter
                    </Button>
                  )}
                </Modal.Footer>
              </Modal>
              {/* <select class='form-select' value="">
            {exclusionPurpose &&
              exclusionPurpose.map(({ label, id }, index) => {
                return (
                  <option value={id}>
                    {label}
                  </option>
                );
              })}
          </select> */}
            </div>
            {isFeatchingArticles && (
              <div className="progressBarData">
                <ProgressBar now={progress} />
              </div>
            )}
          </div>
          <div className="row">
            {filteredArticles &&
              filteredArticles?.length > 0 &&
              filteredArticles?.map(
                (
                  {
                    title,
                    authors,
                    journal,
                    abstract,
                    id,
                    file_path,
                    abstract_screening,
                    current_stage,
                    reason,
                    doi,
                    year,
                  },
                  index
                ) => (
                  <div className="row" key={index}>
                    {/* Handle Background Color Change On Include, Exclude  */}
                    {/* <div className='inner--box--row'  style={{ backgroundColor: isGreen[index] ? "rgba(0,255,0,0.2)" : isRed[index] ? "rgba(255,0,0,0.2)" : "" }}></div> */}
                    {/* <div className={(excluded.includes(id) ? 'inner--box--row red' : 'inner--box--row')} style={{ backgroundColor: isGreen[index] ? "rgba(0,255,0,0.2)" : isRed[index] ? "rgba(255,0,0,0.2)" : "" }}> */}
                    <div
                      className={
                        current_stage > 3
                          ? "inner--box--row green"
                          : reason !== null && current_stage == 3
                          ? "inner--box--row red"
                          : "inner--box--row"
                      }
                      style={{
                        backgroundColor: isGreen[index]
                          ? "rgba(0,255,0,0.2)"
                          : isRed[index]
                          ? "rgba(255,0,0,0.2)"
                          : "",
                      }}
                    >
                      <span className="index--numbering fw-bold">
                        {index + 1})
                      </span>
                      <div className="row width-100">
                        <div className="width--70">
                          {/* <label className='form-check-label' htmlFor='flexCheckDefault2'>
                      {Title}
                    </label> */}
                          <h1 className="heading3">
                            {parse(
                              formatOvidTags(
                                convertFirstLetterToUpperCase(title)
                              )
                            )}
                          </h1>
                          {authors && authors !== "?" ? (
                            <div className="d-flex ">
                              <p className="small text-muted authors-font ms-1">
                                <span className="authors-font fw-bold">
                                  Author(s):
                                </span>{" "}
                                {highlightText(
                                  capitalizeWords(authors.replace(/,/g, ", ")) +
                                    ".",
                                  normalizedValues
                                )}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          {journal ? (
                            <label
                              className="small text-muted journal-font"
                              htmlFor="flexCheckDefault2"
                            >
                              <span className="fw-bold">Journal:</span>{" "}
                              {highlightText(
                                capitalizeWords(journal) + ".",
                                normalizedValues
                              )}
                            </label>
                          ) : (
                            ""
                          )}
                          <div>
                            {year ? (
                              <label className="small text-muted journal-font">
                                <span className="fw-bold">Year:</span>{" "}
                                {highlightText(year, normalizedValues)}
                              </label>
                            ) : (
                              ""
                            )}{" "}
                          </div>

                          {/* <h1 className='heading3'>{Journal}</h1> */}
                          {/* <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault2"
                          >
                            {journal ? <label className="small text-muted">
                              {journal}{" "}
                            </label> : ""}
                            {doi ? <label className="small text-muted">
                              {" "}
                              doi:{" "}
                              {doi ? doi.split("https://dx.doi.org/")[1] : ""}
                            </label> : ""}

                            <p
                              className="small text-muted"
                              htmlFor="flexCheckDefault2"
                            >
                              PMID: {id}
                            </p>
                          </label> */}

                          <p
                            className={
                              activeAbstract === index
                                ? "Increase-height--of--paragraph cursor-pointer"
                                : "Increase-height--of--paragraph underline-showAbstarct"
                            }
                            onClick={() => toggleAbstract(index)}
                            
                          >
                            {activeAbstract === index && abstract
                              ? parse(formatOvidTags(abstract))
                              : "Show Abstract"}
                          </p>
                        </div>

                        <div className="width-30 ">
                          <div className="d-flex flex-column">
                            <div className="">
                              <div className="btn--new--ul">
                                {file_path === null ? (
                                  <span style={{ display: "inline-block" }}>
                                    <Link
                                      to="#"
                                      data-bs-toggle="tooltip"
                                      className="link"
                                      title="Upload or Link File"
                                      onClick={() =>
                                        handleOpenModal2(index, id)
                                      }
                                    >
                                      <img src={paperclip} alt="" />
                                    </Link>
                                    <br />
                                    <span className="upload-link-file"></span>
                                    <Modal
                                      className="modal-dialog-centered "
                                      show={showDelete}
                                      onHide={handleDeleteClose}
                                      backdrop="static"
                                      keyboard={false}
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>Confirm!</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        This Article is Without File Would You
                                        Like to Delete it?
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={handleDeleteClose}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          variant="danger"
                                          onClick={handleDeleteArticle}
                                        >
                                          Delete
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>

                                    {/*  */}
                                  </span>
                                ) : (
                                  <Link
                                    to="#"
                                    data-bs-toggle="tooltip"
                                    className="link"
                                    title="View"
                                    onClick={() => handleOpenModal(index, id)}
                                  >
                                    {/* <img src={paperclip} /> */}
                                    <FaEye />
                                  </Link>
                                )}

                                {getPermission && getPermission.includes(3) ? (
                                  <>
                                    <Link
                                      to="#"
                                      data-bs-toggle="tooltip"
                                      className="link position-relative"
                                      title="Add Note"
                                      onClick={() => handleClick(index)}
                                    >
                                      {savedNotes[id] && (
                                        <span className="dot"></span>
                                      )}
                                      <FaStickyNote />
                                    </Link>

                                    {isRed[index] ||
                                    isGreen[index] ||
                                    current_stage > 3 ||
                                    reason !== null ? (
                                      <Link
                                        to="#"
                                        data-bs-toggle="tooltip"
                                        className="link"
                                        title="Undo"
                                        onClick={() =>
                                          handleUndo(
                                            index,
                                            id,
                                            current_stage,
                                            reason
                                          )
                                        }
                                      >
                                        <GrRotateLeft />
                                      </Link>
                                    ) : (
                                      <span>
                                        {/* <Link
                                          to="#"
                                          data-bs-toggle="tooltip"
                                          className="link"
                                          title="Include"
                                          onClick={() =>
                                            handleInclude(index, id)
                                          }
                                          disabled={file_path === null}
                                        >
                                          <FaPlus />
                                        </Link> */}

                                        <button
                                          type="button"
                                          className={
                                            file_path === null
                                              ? "link include-btn-disable"
                                              : "link"
                                          }
                                          title="Include"
                                          onClick={() =>
                                            handleInclude(index, id)
                                          }
                                          disabled={file_path === null}
                                          data-bs-toggle="tooltip"
                                        >
                                          <FaPlus />
                                        </button>

                                        <Link
                                          to="#"
                                          data-bs-toggle="tooltip"
                                          className="link"
                                          title="Exclude"
                                          onClick={() =>
                                            handleExclude(
                                              index,
                                              id,
                                              current_stage,
                                              abstract_screening
                                            )
                                          }
                                        >
                                          <FaMinus />
                                        </Link>
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>

                            <div className="">
                              {isRed[index] || reason !== null ? (
                                <div className="w-75 ms-auto">
                                  <label className="mt-2 text-danger">
                                    Reason for Exclusion?
                                  </label>
                                  <select
                                    class="form-select"
                                    defaultValue={reason}
                                    onChange={(event) =>
                                      handleSelectChange(event, index, id)
                                    }
                                  >
                                    <option value="0" selected disabled>
                                      Please select option
                                    </option>
                                    {exclusionPurpose &&
                                      exclusionPurpose?.map(
                                        ({ label, value }, index) => {
                                          return (
                                            <option value={value}>
                                              {label}
                                            </option>
                                          );
                                        }
                                      )}
                                  </select>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {isActive === index && (
                          <NoteComponent
                            id={id}
                            notes={notes}
                            handleChangeNote={handleChangeNote}
                            handleSaveNote={handleSaveNote}
                            isSavingNote={isSavingNote}
                            savedNotes={savedNotes}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            {showModal2 && (
              <Modal
                className="modal-lg abstract--modal file-upload-modal modal-dialog-centered vertical-align-center overflow-hidden"
                show={showModal2}
                onHide={handleCloseModal2}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header className="pt-5">
                  <h2 className="mb-2 Active--learning--heading">
                    Upload File or Add Link
                  </h2>
                  <button
                    className="btn-close"
                    onClick={handleCloseModal2}
                  ></button>
                </Modal.Header>

                <Tabs
                  className="text-dark included-file-upload-tabs"
                  activeKey={tabKey}
                  onSelect={(e) => initTabKey(e)}
                >
                  <Tab
                    eventKey="one"
                    title="File"
                    className="modal--tab-buttons"
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mt-2 data-set-upload">
                          <form
                            onSubmit={handleSubmit}
                            className="form--ris-modal"
                          >
                            {/* Drag-and-Drop Area */}
                            <div className="upload-file-box">
                              {!getFileName && (
                                <div
                                  className="cursor-pointer file-upload-box-secondary"
                                  onClick={() =>
                                    document
                                      .getElementById("fileUpload")
                                      .click()
                                  }
                                  onDrop={handleDrop}
                                  onDragOver={handleDragOver}
                                >
                                  <div className="upload-file-logo">
                                    <AiOutlineCloudUpload size={150} />
                                    <p>
                                      Drag and drop a file or click to select
                                    </p>
                                  </div>
                                  <input
                                    id="fileUpload"
                                    type="file"
                                    name="myFile"
                                    required
                                    style={{ display: "none" }}
                                    onChange={handleFileSelect}
                                    disabled={!!dataSetUrl}
                                  />
                                </div>
                              )}
                              {/* Progress Bar Section */}
                              {showProgressBar && (
                                <div
                                  className="card mt-4 p-3 position-relative"
                                  style={{
                                    width: "100%",
                                    maxWidth: "120vh",
                                    margin: "0 auto",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    padding: "15px",
                                    boxShadow: "none",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  <FaRegFileAlt
                                    size={40}
                                    style={{ marginRight: "10px" }}
                                  />
                                  <div
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <p
                                      style={{
                                        marginBottom: "5px",
                                        fontSize: "18px",
                                        padding: "0px 5px",
                                      }}
                                    >
                                      {selectedFile.name}
                                    </p>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {/* Blue progress bar */}
                                      <ProgressBar
                                        now={progress1}
                                        variant="primary"
                                        style={{
                                          flex: 1,
                                          backgroundColor: "#e0e0e0",
                                          marginRight: "10px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* File Name Section */}
                              {getFileName && !showProgressBar && (
                                <div
                                  className="card mt-4 p-3 position-relative"
                                  style={{
                                    width: "100%",
                                    maxWidth: "120vh",
                                    margin: "0 auto",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    padding: "15px",
                                    boxShadow: "none",
                                    height: "90px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  <FaTimes
                                    size={20}
                                    style={{
                                      position: "absolute",
                                      top: "35px",
                                      right: "10px",
                                      cursor: "pointer",
                                      color: "red",
                                    }}
                                    onClick={handleCancelFile}
                                  />
                                  <FaRegFileAlt
                                    size={40}
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <p
                                      style={{
                                        marginBottom: "5px",
                                        fontSize: "18px",
                                        display: "flex",
                                        padding: "0px 5px",
                                      }}
                                    >
                                      {selectedFile.name}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Upload Button */}
                            <button
                              type="submit"
                              // className="btn btn-lg btn-success upload-file-ris"
                              // className= {!isFileUploaded ? "btn btn-lg btn-success cursor-not-allowed" :"btn btn-lg btn-success" }
                              className={
                                !isFileUploaded
                                  ? "upload-btn-disable upload-btn"
                                  : "upload-btn"
                              }
                              disabled={!isFileUploaded}
                            >
                              Upload File
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  {/* <Tab
                                eventKey="one"
                                title="File"
                                className="modal--tab-buttons"
                              >
                                <div className="row">
                                  <div className="col-lg-12">
                                    <h1>{}</h1>
                                    <div className="mt-2 data-set-upload">
                                      <form
                                        onSubmit={handleSubmit}
                                        className="form--ris-modal"
                                      >
                                        {!getFileName ? (
                                          <span
                                            className="text-info drag--drop-font"
                                            style={{ fontSize: "22px" }}
                                          >
                                            Drag and drop file here, or click to
                                            select file
                                          </span>
                                        ) : (
                                          <span
                                            id="fileName"
                                            className="text-info"
                                            style={{ fontSize: "22px" }}
                                          >
                                            {getFileName}
                                          </span>
                                        )}
                                        <input
                                          id="fileUpload"
                                          type="file"
                                          name="myFile"
                                          required
                                          className="inputFileRis"
                                          onChange={handleFileSelect}
                                        />
                                        <input
                                          type="submit"
                                          value={
                                            isFileSubmitting
                                              ? "Uploading File..."
                                              : "Upload File"
                                          }
                                          disabled={isFileSubmitting}
                                          className="btn btn-lg btn-success upload-file-ris "
                                        />
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </Tab> */}
                  <Tab
                    eventKey="two"
                    title="URL"
                    className="modal--tab-buttons"
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mt-2 data-set-upload">
                          <form
                            onSubmit={handleUrlSubmit}
                            className="form--ris-modal"
                          >
                            <div>
                              <span className="d-flex justify-content-start mb-3">
                                <span
                                  className="text-info "
                                  style={{ fontSize: "22px" }}
                                >
                                  Dataset URL
                                </span>
                              </span>
                              <input
                                id="fileUpload"
                                style={{ height: "60px" }}
                                type="text"
                                value={dataSetUrl}
                                name="myFile"
                                required
                                className={`form-control ${
                                  error ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                disabled={!!getFileName}
                              />
                              <div className="error-message">
                                <span id="urlError" className="text-danger">
                                  {error}
                                </span>
                              </div>
                            </div>
                            <div className="button-wrapper">
                              <input
                                type="submit"
                                value="Add URL"
                                className={
                                  !dataSetUrl
                                    ? "upload-btn-disable upload-btn"
                                    : "upload-btn"
                                }
                                disabled={!dataSetUrl}
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </Modal>
            )}
            {show && (
              <>
                <div className="template_modal z-index-99">
                  <div className="template_modal-wrapper">
                    <div className="modal--header">
                      <div className="text-end">
                        <button
                          className="btn-danger"
                          onClick={() => {
                            handleCloseModal();
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <div className="modal--body">
                      {source && (
                        <iframe
                          width="100%"
                          title="attached file"
                          src={`${source}`}
                        ></iframe>
                      )}
                      {file && (
                        <iframe
                          width="100%"
                          title="attached file"
                          src={`${API_SRC + "/" + file}`}
                        ></iframe>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {!isFeatchingArticles &&
              options.length === 0 &&
              !isError &&
              isFetchingArticlesAPICalled && (
                <div className="no-data-found-main">
                  <h4 className="no-data-found text-muted m-auto opacity-50">
                    <FaExclamationTriangle size={50} color="orange" />
                    <span className="ms-3">
                      {" "}
                      There are no fulltext screening articles with dataset.
                    </span>
                  </h4>
                </div>
              )}
            {isError && !isFeatchingArticles && isFetchingArticlesAPICalled && (
              <div className="no-data-found-main">
                <h4 className="no-data-found text-muted m-auto opacity-50">
                  <BiErrorCircle size={50} color="orange" />
                  <span className="ms-3"> Some thing went wrong.</span>
                </h4>
              </div>
            )}
            {isFeatchingArticles && (
              <div
                className={
                  options.length >= 25 ? "loading-second-time" : "preload"
                }
              >
                <img src={gif} alt="Loading..." />
              </div>
            )}
          </div>
        </div>
      </div>

      {/*  */}

      {/*  */}
    </>
  );
}

export default TotalReviews;
